import React, { useEffect, useRef, useState } from "react";
import Peer from "simple-peer";

function VideoCall(props) {

	const [ receivingCall, setReceivingCall ] = useState(false)
	const [ callerSignal, setCallerSignal ] = useState()
	const [ callAccepted, setCallAccepted ] = useState(false)
	const [ callEnded, setCallEnded] = useState(false)
	const [ name, setName ] = useState("")          
	const myVideo = useRef()
	const userVideo = useRef(null)
	const connectionRef= useRef()

	async function handleClick(){
		myVideo.current.style.display="block";
		userVideo.current.style.display="block";

		const stream = await navigator.mediaDevices.getUserMedia({video: true, audio: true});
	    myVideo.current.srcObject = stream;

		const peer = new Peer({
			initiator: true,
			trickle: false,
			stream: stream
	    	})

		props.socket.emit("roomId",props.roomId);
			props.socket.on("calledto", (arr) => {
	   			var opponent = arr.filter(id=>{
					return id!== props.socket.id;
	   				})
				if(opponent.length===0){
					alert(`Please ask ${props.opposeUser} to join chat`);
					window.location.reload(true);
				}

			peer.on("signal", (data) => {
				props.socket.emit("callUser", {
					userToCall: opponent[0],
					signalData: data,
					from: props.socket.id,
					name: props.me
				})
			})
		})

		props.socket.on("callAccepted", async (signal) => {
				setCallAccepted(true)
				peer.signal(signal)
			})

		peer.on("stream", (stream) => {
		userVideo.current.srcObject = stream	
		})
		connectionRef.current = peer
	
	}

	useEffect(() => {
		props.socket.on("callUser", (data) => {
			setReceivingCall(true)
			setName(data.name)
			setCallerSignal(data.signal)
			myVideo.current.style.display="block";
			userVideo.current.style.display="block";
		})

		props.socket.on("connectionbreak",data=>{
			console.log(data);
			if(data.destroy){
				window.location.reload(true);
			}
		})
	}, [props.socket])
	

	 const answerCall = async() =>  {
		setCallAccepted(true);
		const stream = await navigator.mediaDevices.getUserMedia({video: true, audio: true});
	    myVideo.current.srcObject = stream;

		const peer = new Peer({
			initiator: false,
			trickle: false,
			stream: stream
		})
		props.socket.emit("roomId",props.roomId);
		props.socket.on("calledto", (arr) => {
		   var opponent = arr.filter(id=>{
			return id!== props.socket.id;
		   })
		   peer.on("signal", (data) => { 
			props.socket.emit("answerCall", { signal: data, to: opponent[0] })
		})
		peer.on("stream", (stream) => {
			userVideo.current.srcObject = stream;
		})

		peer.signal(callerSignal)
		connectionRef.current = peer
		})
		
	}

	const leaveCall = () => {
		setCallEnded(true)
		connectionRef.current.destroy();
		   props.socket.emit("destroyConnection",props.roomId);
		
		window.location.reload(true);
	}
  
  return (
    <div >
      <li onClick={handleClick}><i class="fa-solid fa-video"></i></li>
    
       <div className="makeabsolute">
       		<div className="video-container">
				<div className="video">
					 <video className="video1" playsInline muted ref={myVideo} autoPlay  />
				</div>
				<div className="video">
					
					<video playsInline ref={userVideo} autoPlay className="video2" />
				</div>
			</div>
			<div className="call-button">
					{callAccepted && !callEnded ? (
						<button  onClick={leaveCall}>
							End Call
						</button>
					) :null}
				</div>
				<div>
			
			</div>
       </div>
     
	  {receivingCall && !callAccepted ? (
						<div className="caller">
						<h1 >{name} is calling...</h1>
						<button  onClick={answerCall}>
							Answer
						</button>
					</div>
				) : null}
    </div>
  )
}

export default VideoCall